<template>
  <div
    v-if="secondAdTile"
    id="taboola-homepage-thumbnails---d"
    v-tab-ad
    data-widget-id="taboola-homepage-thumbnails---d"
    @click="sendAdClickEvent('taboola-homepage-thumbnails---d')"
  />
  <div
    v-else
    :id="`taboola-thumbnails-d-${props.counter}`"
    v-tab-ad
    @click="sendAdClickEvent('taboola-thumbnails-d-' + props.counter)"
  />
</template>
<script setup>
  import { sendMixpanelEvent } from '~/utils/host-browser-apis'
  import { getSource } from '~/utils/host-browser-apis/analytics/helper'

  const props = defineProps({
    gridPosition: {
      type: Number,
      default: 0,
    },
    counter: {
      type: String,
      default: '',
    },
    secondAdTile: {
      type: Boolean,
      default: false,
    },
  })

  const getEventData = async (creativeId) => {
    const eventData = {
      ntp_tile_position: props.gridPosition,
      ntp_ad_provider: 'taboola',
      ntp_ad_brand: await getSource('TaboolaV5', creativeId),
      ntp_creative_id: creativeId,
    }
    return eventData
  }

  const sendAdClickEvent = async (creativeId) => {
    await sendMixpanelEvent('NtpAd_Clicked', await getEventData(creativeId))
  }

  const vTabAd = {
    mounted: async (element) => await sendMixpanelEvent('NtpAd_Rendered', await getEventData(element.id)),
  }

  if (process.client) {
    useTaboolaAds()
  }

  onMounted(() => {
    const secondTileAdScriptDiv = document.getElementById('taboola-homepage-thumbnails---d')

    if (secondTileAdScriptDiv && !secondTileAdScriptDiv.hasChildNodes()) {
      const secondTileAdScript = document.createElement('script')

      secondTileAdScript.type = 'text/javascript'
      secondTileAdScript.text = `window._taboola = window._taboola || [];
      _taboola.push({
        mode: 'thumbnails-d',
        container: 'taboola-homepage-thumbnails---d',
        placement: 'homepage thumbnails-d-0',
        target_type: 'mix'
      });`

      secondTileAdScriptDiv.appendChild(secondTileAdScript)
    }

    const adsScriptDiv = document.getElementById('taboola-thumbnails-d-' + props.counter)

    if (adsScriptDiv && !adsScriptDiv.hasChildNodes()) {
      const adsScript = document.createElement('script')
      adsScript.type = 'text/javascript'
      adsScript.text = `window._taboola = window._taboola || [];
      _taboola.push({
        mode: 'thumbnails-d',
        container: 'taboola-thumbnails-d-${props.counter}',
        placement: 'thumbnails-d-${props.counter}',
        target_type: 'mix'
      });`

      adsScriptDiv.appendChild(adsScript)
    }
  })
</script>
